export default __webpack_public_path__ + "static/media/am_homecare_mega_menu.f8fbc3b2.jpg";